export type NotificationProvider = 'email' | 'slack' | 'whatsapp' | 'teams'

/** Alerts still uses the legacy wire key `mail`; normalize it at the shared notification boundary. */
export type NotificationProviderKey = NotificationProvider | 'mail'

export function normalizeNotificationProvider(
  provider: NotificationProviderKey,
): NotificationProvider {
  return provider === 'mail' ? 'email' : provider
}
